import { Accordion, AccordionItem } from '@carbon/react';
import { useLoadableAtomValue } from 'lib/hooks/useLoadableAtomValue';
import { SlotTable } from './slot-table';
import { EntitySlotSummary } from './entity-slot-summary';
import { entitySlotsByFormationAtom } from './atoms';
import { SlotFormationTable } from 'components/slots-by-formation-table';
import { SlotsByFormationResponse } from 'types/api-responses';
import styles from './slots-tab.module.scss';

interface SlotsTabProps {
  entityId: number;
}

export const SlotsTab = ({ entityId }: SlotsTabProps) => {
  const slotsByFormationData = useLoadableAtomValue<
    SlotsByFormationResponse,
    Error
  >(entitySlotsByFormationAtom(entityId));

  const isSlotsByFormationLoading = slotsByFormationData.state === 'loading';
  const slotsByFormation =
    slotsByFormationData.state === 'hasData'
      ? slotsByFormationData.data
      : undefined;

  return (
    <>
      <EntitySlotSummary entityId={entityId} displayMode="slots" />
      <Accordion className={styles.accordionContainer}>
        <AccordionItem
          title={
            <span className={styles.accordionTitle}>
              Horizontal Slots by Basin/Formation
            </span>
          }
          open={true}
        >
          <SlotFormationTable
            horizontalSlotsByFormation={slotsByFormation}
            isLoading={isSlotsByFormationLoading}
            tableId={`entity-${entityId}-slots-by-formation`}
          />
        </AccordionItem>
      </Accordion>
      <SlotTable entityId={entityId} />
    </>
  );
};
